import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      // Wait a frame so the target section has rendered.
      const id = window.requestAnimationFrame(() => document.getElementById(hash.slice(1))?.scrollIntoView({
        block: "start"
      }));
      return () => window.cancelAnimationFrame(id);
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return null;
}